"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgDefault = function SvgDefault(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0c7.543 0 11.314 0 13.657 2.343S32 8.458 32 16c0 7.543 0 11.314-2.343 13.657S23.543 32 16 32c-7.542 0-11.314 0-13.657-2.343S0 23.543 0 16z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6.676c-6.107 0-10.71 4.037-10.71 8.629 0 2.948 1.86 5.635 4.846 7.216l.599.318-.073.674a6.016 6.016 0 0 1-.939 2.657 11.213 11.213 0 0 0 4.102-2.097l.323-.262.415.045c.47.05.95.077 1.437.077 6.107 0 10.71-4.037 10.71-8.628 0-4.592-4.603-8.629-10.71-8.629zM3.29 15.305C3.29 9.26 9.173 4.676 16 4.676c6.827 0 12.71 4.584 12.71 10.629 0 6.044-5.883 10.628-12.71 10.628-.419 0-.833-.017-1.242-.05-1.856 1.408-4.615 2.703-8.185 2.703l-.37-1.929c.704-.28 1.938-1.174 2.354-2.732-3.136-1.896-5.267-5.012-5.267-8.62z",
    fill: "#007AFF"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgDefault);
var _default = exports["default"] = Memo;